import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../config/apiClient";
import API_ENDPOINTS from "../config/api";

const initialState = {
  movie:         null,
  movie_loading: false,
  movie_error:   null,

  tv_show:         null,
  tv_show_loading: false,
  tv_show_error:   null,
};

export const fetchMovieDetail = createAsyncThunk(
  "detail/fetchMovieDetail",
  async (slug, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(API_ENDPOINTS.MOVIE_DETAIL(slug));
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchTvShowDetail = createAsyncThunk(
  "detail/fetchTvShowDetail",
  async (slug, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(API_ENDPOINTS.TV_SHOW_DETAIL(slug));
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const detailSlice = createSlice({
  name: "detail",
  initialState,
  reducers: {
    clearMovieDetail:  (state) => { state.movie = null; state.movie_error = null; },
    clearTvShowDetail: (state) => { state.tv_show = null; state.tv_show_error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMovieDetail.pending,   (state) => { state.movie_loading = true; state.movie_error = null; })
      .addCase(fetchMovieDetail.fulfilled, (state, action) => { state.movie_loading = false; state.movie = action.payload; })
      .addCase(fetchMovieDetail.rejected,  (state, action) => { state.movie_loading = false; state.movie_error = action.payload; })

      .addCase(fetchTvShowDetail.pending,   (state) => { state.tv_show_loading = true; state.tv_show_error = null; })
      .addCase(fetchTvShowDetail.fulfilled, (state, action) => { state.tv_show_loading = false; state.tv_show = action.payload; })
      .addCase(fetchTvShowDetail.rejected,  (state, action) => { state.tv_show_loading = false; state.tv_show_error = action.payload; });
  },
});

export const { clearMovieDetail, clearTvShowDetail } = detailSlice.actions;
export default detailSlice.reducer;
